<template>
  <div class="career_slider">
   
      <div class="career_slider__inner container">
                  <swiper :options="swiperOptions">
  
                    <swiper-slide :key="index" v-for="(story, index) in content" class="career_slider__slide flex column bg-white">
                            <div class="career_slider__overlay bg-overlay">

                            </div>

                      <picture>
                                <source media="(max-width: 1023px)" :srcset="_.get(story, 'images[0].devices.tablet')">
                                <source media="(max-width: 767px)" :srcset="_.get(story, 'images[0].devices.mobile')">
                                                    <img :src="_.get(story, 'images[0].devices.desktop')" class="cover"
                                                  :alt="$route.name == 'PageViewRouter_ge' && _.get(story, 'seo_keywords_ge' ) ? _.get(story, 'seo_keywords_ge ') : $route.name == 'PageViewRouter_en' && _.get(story,'seo_keywords_en' ) ? _.get(story, 'seo_keywords_en ') : ''">
                                </picture>


                      <div class="career_slider__text-box flex column wc">
                          <p class="f-21 medium f-white" v-if="windowWidth >= 768">{{  _.get(story, 'teaser')}}</p>
                            <h2 class="f-14 medium f-white">{{_.get(story, 'title')}}</h2>
                      <h3 class="f-14 medium f-white">{{_.get(story, 'sub_title')}}</h3>
                      </div>
           
                  

                    </swiper-slide>
                </swiper>
      </div>

   
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
  export default {
    props: ['contentData'],
    mixins: [resize_handler],
    data () {
      return {
      
        swiperOptions: {
          slidesPerView: "auto",
          spaceBetween: 0,
          grabCursor: true,
            speed: 1300,
            loop: true,
            watchOverflow: true,
            resistanceRatio: 0,
            // centeredSlides: true,
            // centeredSlidesBounds: true,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            initialSlide: 1,
            shortSwipes: true,
         
    
       
            on: {
            touchMove() {
                if ( document.querySelectorAll(".career_slider .swiper-slide").length >= 2) {
                    document
                        .querySelectorAll(".career_slider .swiper-slide")
                        .forEach((slide) => {
                            slide.style.transform = "scale(0.9, 0.9)";
                        });
                }
            },
            touchEnd() {
                if ( document.querySelectorAll(".career_slider .swiper-slide").length >= 2) {
                    document
                        .querySelectorAll(".career_slider .swiper-slide")
                        .forEach((slide) => {
                            slide.style.transform = "scale(1, 1)";
                        });
                }
            },
        },
          pagination: {
      
          },
    
        }
      }
    },
    computed: {
      main_title(){
        return _.get(this.contentData, 'conf.header.title');
      },
      content(){
        return _.get(this.contentData, 'data.list');
      },

    },
    mounted() {
        console.log(this.content)
    },

    methods: {
   
    }
  }
</script>